import { render, staticRenderFns } from "./CoveragePlans.vue?vue&type=template&id=4dfc585a"
import script from "./CoveragePlans.vue?vue&type=script&lang=js"
export * from "./CoveragePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports